import React from "react";
import { Navigate, Route, Routes, BrowserRouter as Router } from "react-router-dom";
import ScrollToTop from "./common/ScrollToTop";

import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux';
import { persistor, store } from "./store/store";
import { NotFound } from "./views/NotFound";

import ROIPage from "./views/pages/roi-calculator/ROIPage";

import ROIPageCondition from "./views/pages/roi-calculator/ROIPageCondition.js";

import ROIReportSingle from "./views/pages/roi-calculator/ROIReportSingle";
import ROIReport from "./views/pages/roi-calculator/ROIReport";
import ROIForm from "./views/pages/roi-calculator/ROIForm";
import CustomComponents from "./views/pages/roi-calculator/CustomComponents";

import ROIReportSubmitted from "./views/pages/roi-calculator/ROIReportSubmitted.js";

import 'react-toastify/dist/ReactToastify.css';

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ScrollToTop>
          <Routes>
            <Route path="/not-found" element={<NotFound />} />
            <Route path="/roi/condition" element={<ROIPageCondition />} />
            <Route path="/roi/form/:roiId" element={<ROIForm />} />
            <Route path="/roi/report" element={<ROIReport />} />
            <Route path="/roi/report-single" element={<ROIReportSingle />} />
            <Route path="/roi/custom-component" element={<CustomComponents />} />
            <Route
              path="/roi/:roiId/report/:submittedID"
              element={<ROIReportSubmitted />}
            />
            <Route path="/roi/:roiId" element={<ROIPage />} />
            <Route path="/" element={<Navigate to="/not-found" replace />} />
            <Route path="*" element={<Navigate to="/not-found" replace />} />
          </Routes>

        </ScrollToTop>
      </PersistGate>
    </Provider >
  );
}

export default App;
